
import { defineComponent, provide } from 'vue';
import { NConfigProvider } from 'naive-ui';
import Header from '@/components/nav/Header.vue';
import Error from '@/components/Error.vue';
import { useAuth0 } from '@/auth';
import { InjectionKeys } from '@/constants';
import ToastProvider from '@/providers/Toast/ToastProvider.vue';

export default defineComponent({
  name: 'App',
  components: {
    ToastProvider,
    Header,
    Error,
    NConfigProvider
  },
  setup() {
    const auth = useAuth0();
    provide(InjectionKeys.Auth, auth);

    const primaryColor = '#277C78';
    return {
      /**
       * @type import('naive-ui').GlobalThemeOverrides
       */
      themeOverrides: {
        common: {
          primaryColor,
          primaryColorHover: '#175F5C',
          warningColor: '#E5A612',
          errorColor: '#B30518',
          textColorBase: '#353535',
          textColor1: '#161618',
          textColor2: '#353535',
          textColor3: '#707070'
        },
        Table: {
          borderColor: primaryColor
        },
        Button: {
          textColor: primaryColor,
          colorHoverPrimary: '#175F5C',
          colorPressedPrimary: '#105350',
          colorHoverError: '#990021',
          colorPressedError: '#77001B'
        },
        LoadingBar: {
          colorLoading: primaryColor
        }
      },
      ...auth
    };
  }
});
